/**
 * [INPUT]: 依赖 cartesian context 线性 y-scale 与可选 tickFormatter
 * [OUTPUT]: 对外提供可配 tick 数量/间距的左 YAxis 与右 YRightAxis SVG 标签层
 * [POS]: 直角坐标图的非负数值双轴标签，共享 controller 两套自动 nice domain
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { useChartPart } from "./chart-context"

export function YAxis({
  tickFormatter,
  tickCount = 4,
  tickMargin = 8
}) {
  const ctx = useChartPart("YAxis")
  if (!ctx.ready) return null

  return (
    <g className="fill-current font-mono text-[10px] text-muted-foreground">
      {ctx.y.ticks(tickCount).map((t) => (
        <text
          key={t}
          x={-tickMargin}
          y={ctx.y(t)}
          textAnchor="end"
          dominantBaseline="central"
          fill="currentColor">
          {tickFormatter ? tickFormatter(t) : t}
        </text>
      ))}
    </g>
  );
}

export function YRightAxis({
  tickFormatter,
  tickCount = 4,
  tickMargin = 8
}) {
  const ctx = useChartPart("YRightAxis")
  if (!ctx.ready) return null

  return (
    <g className="fill-current font-mono text-[10px] text-muted-foreground">
      {ctx.yRight.ticks(tickCount).map((tick) => (
        <text
          key={tick}
          x={ctx.plot.width + tickMargin}
          y={ctx.yRight(tick)}
          textAnchor="start"
          dominantBaseline="central"
          fill="currentColor">
          {tickFormatter ? tickFormatter(tick) : tick}
        </text>
      ))}
    </g>
  )
}
